var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRectangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2166_4522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 0H4.58333C3.36816 0.00132347 2.20314 0.484634 1.34389 1.34389C0.484634 2.20314 0.00132347 3.36816 0 4.58333L0 15.4167C0.00132347 16.6318 0.484634 17.7969 1.34389 18.6561C2.20314 19.5154 3.36816 19.9987 4.58333 20H15.4167C16.6318 19.9987 17.7969 19.5154 18.6561 18.6561C19.5154 17.7969 19.9987 16.6318 20 15.4167V4.58333C19.9987 3.36816 19.5154 2.20314 18.6561 1.34389C17.7969 0.484634 16.6318 0.00132347 15.4167 0ZM17.5 15.4167C17.5 15.9692 17.2805 16.4991 16.8898 16.8898C16.4991 17.2805 15.9692 17.5 15.4167 17.5H4.58333C4.0308 17.5 3.5009 17.2805 3.11019 16.8898C2.71949 16.4991 2.5 15.9692 2.5 15.4167V4.58333C2.5 4.0308 2.71949 3.5009 3.11019 3.11019C3.5009 2.71949 4.0308 2.5 4.58333 2.5H15.4167C15.9692 2.5 16.4991 2.71949 16.8898 3.11019C17.2805 3.5009 17.5 4.0308 17.5 4.58333V15.4167Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_4522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRectangleIcon);
export default __webpack_public_path__ + "static/media/editRectangleIcon.bf646d6b85cbcab144333fd1827faeeb.svg";
export { ForwardRef as ReactComponent };